import { Profile } from "./config";

export const EditorMapper = {
  html: "htmlmixed",
  css: "css",
  javascript: "javascript",
  php: "php",
  python: "python",
  sql: "sql",
  perl: "perl",
  ruby: "ruby",
  sass: "sass",
  swift: "swift",
  vb: "vb",
  vue: "vue",
  xml: "xml",
  c: "clike",
  "c++": "clike",
  "c#": "clike",
  "objective-c": "clike",
  java: "clike",
  scala: "clike",
  kotlin: "clike",
  ceylon: "clike",
};

export const EntityType = {
  Commitment: "commitment",
};
export const NotificationType = {
  Message: "Message",
  Info: "Info",
  Warning: "Warning",
  FeedBack: "Feedback",
  Kudos: "Kudos",
  Tip: "Tip",
};
export const NotificationSection = {
  Timesheet: "Timesheet",
  Payrun: "Payrun",
  Other: "Other",
};
export const Fields = {
  Customers: {
    Users: "Users",
    AdminOfCustomer: {
      Email: "Email",
      Name: "Name",
    },
  },
  Teammember: {
    Id: "Id",
    UserAccountsId: "UserAccountsId",
    Email: "Email",
    SecondaryEmail: "SecondaryEmail",
    FirstName: "FirstName",
    LastName: "LastName",
    Mobile: "Mobile",
    FirebaseUDID: "FirebaseUDID",
    UserName: "UserName",
    FullName: "FullName",
    CareerHistories: "CareerHistories",
  },
  TextValues: {
    Cat: "Cat",
    Text: "Text",
    Value: "Value",
  },
  Commitments: {
    TeamMemberIds: "TeamMemberIds",
    ProjectIds: "ProjectIds",
    CustomerIds: "CustomerIds",
  },
  Projects: {
    ProjectName: "ProjectName",
    Customerss: "Customerss",
  },
  Epics: {
    ProjectId: "ProjectId",
    Items: "Items",
  },
  Timesheets: {
    Date: "Date",
    Adjustment: "Adjustment",
    TeamMemberId: "TeamMemberId",
    ProjectId: "ProjectId",
  },
  Accesses: {
    Project: {
      Id: "Project.id",
    },
  },
  Leave: {
    Teammember: {
      id: "Teammember.id",
    },
    Date: "Date",
  },
  Repositories: {
    Id: "Id",
    Commits: {
      Date: "Date",
    },
  },
  CareerHistories: {
    Teammember: {
      id: "Teammember.id",
    },
  },
  Assessments: {
    Teammember: "TeammemberId",
  },
  PayRuns: {
    TeamMemberId: "TeamMemberId",
  },
};
export const DateRange = ["This Week", "Last Week", "Last Month", "This Month", "Last Year", "This Year"];
export const TestUserEmailPath = "codeclan.org";
export const CollectionsNames = {
  CoreSkills: "CoreSkills",
  Users: "Users",
  Teammember: "Teammember",
  Reviews: "Reviews",
  Traits: "Traits",
  Projects: "Projects",
  TextValues: "TextValues",
  Technologies: "Technologies",
  Activities: "Activities",
  Commitment: "Commitment",
  LineManagers: "LineManagers",
  SalesReps: "SalesReps",
  ProjectLeads: "ProjectLeads",
  ProjectManagers: "ProjectManagers",
  Assessment: "Assessment",
  AuditTrail: "AuditTrail",
  PublicHoliday: "PublicHoliday",
  Epics: "Epics",
  Timesheets: "Timesheets",
  Customers: "Customers",
  Accesses: "Accesses",
  Leave: "Leave",
  Repositories: "Repositories",
  Repositories_Commits: "Commits",
  Authors: "Authors",
  CareerHistories: "CareerHistories",
  PayRuns: "PayRuns",
};
export const Paths = {
  Client: {
    Route: "/client",
    Logout: "/logout",
    Login: "/authentication/login",
    Dashboard: "/client/dashboard",
  },
};
export const CommitmentStatus = {
  active: "active",
  expire: "expire",
  upcomming: "upcomming",
};
export const ProjectMessages = {
  existItem: "This item already exist in the list",
  cryptoDuplicateError: "Sorry! You already have the same wallet address.",
  bankDuplicateError: "Sorry! You already have the same bank account.",
  wiseDuplicateError: "Sorry! You already have the same wise account.",
  paypalDuplicateError: "Sorry! You already have the same paypal account.",
  NoProject: "There are no projects in this week!",
  NoProjectsInDates: "No data found for the selected months!",
  NoChartDetailInDates: "No data found, please change your filter!",
  NoTimesheet: "There are no timesheets in this week!",
  WrongEmail: "Wrong email!",
  WrongOrInactiveEmail: "The email is wrong or not active",
  LostConnection: "You have lost your connection!",
  successAddressVerificationAlert: "your Address has been Verified successfully",
  errorVerificationAlert: "wrong verification code!",
  successAddressVerificationNote:
    "Congratulations! Your address has been verified successfully. You can edit your address and do verification steps for your new address by editing your existing address",
  successPhoneNumberVerificationAlert: "your Phone Number has been Verified successfully",
  successPhoneNumberVerificationNote:
    "Congratulations! Your Phone Number has been verified successfully. You can edit your Phone number and do verification steps for your new number by editing your existing address",
  addressSendingCode:
    "Thank you! We will send a code to your address via post for verification. please enter the code in verification field at the top to verify your address after you recieved the code.",
  phoneNumberEnterVerificationCode: "please enter the code in verification field at the top to verify your number after you received the code.",
  addressSaved:
    "Your address has been saved succesfully. Please fill in the captcha then click on 'SEND CODE' button to receive a code via post in 30 days to verify your address.",
  phoneNumberSaved:
    "Your Phone number has been saved successfully. Please fill in the captcha then click on 'SEND CODE' button to receive a code via SMS in 2 minute to verify your number.",
  verificationTimeOver: "Verification time is over. please send the code again",
  timeOver: "Time Over",
  setAsDefaultPhoneMessage:
    "Are you sure? You already have another phone number as your default. the other phone number won't be your default phone number anymore if you click on OK.",
  setAsDefaultAddressMessage:
    "Are you sure? You already have another address as your default. the other address won't be your default address anymore if you click on OK.",
  newPhoneAlert: "Sorry! you already have a new unsaved phone number. to add another one please save or cancel that at first.",
  newAddressAlert: "Sorry! you already have a new unsaved address. to add another one please save or cancel that at first.",
  removeAddressAlert:
    "You can't remove this address. It is the only address as your default. to remove this, you must set another address as your default address at first!",
  removeAddress: "Address removed successfully!",
  removePhoneAlert:
    "You can't remove this phone number. It is the only phone number as your default. to remove this, you must set another address as your default phone number at first!",
  removePhone: "Phone Number removed successfully!",
  phoneLimitAlert: "Sorry! you cannot add more than three phone numbers.",
  addressLimitAlert: "Sorry! you cannot add more than three addresses.",
  // saveAddress: "Please Save your Address to start the verification steps",
  saveAddress: "Your Address saved successfully!",
  // savePhoneNumber: "Please Save your Phone number to start the verification steps",
  savePhoneNumber: "Your Phone Number saved successfully!",
  extraWrongVerifyRequest: "You entered wrong code more than 5 times. your Verification Code has been expired! please send another Code",
  emptyCaptcha: "Sorry! you didn't Fill the captcha.",
  verifiedPhoneNumber: "This Phone Number is already verified!",
  skillRequestSuccess:
    "Thanks for requesting new skill to be added. we will check your request and add the skill as soon as possible. after that you can add this skill",
  JobRequestSuccess:
    "Thanks for requesting new job title to be added. we will check your request and add the job as soon as possible. after that you can add this job",
  DuplicateJobTitle:
    "The job title already exist. you can choose it as your job. you can't send request to add the jobs that already exist in the list!",
  DuplicateSkillTitle:
    "The skill already exist. you can choose it as your skill. you can't send request to add the skills that already exist in the list!",
  error: "Sorry! Something went wrong!",
  favortieSkillLimitation: `This was the last favorite skill you could add. You used all your ${Profile.Members.FavoriteSkillLimit} favorite skill limitation.You can only add ${Profile.Members.FavoriteSkillLimit} skills as your favorites. you should uncheck a skill to be able to add another skill as your favorite!`,
  usedFavoriteSkillLimitation: `You already had used all your ${Profile.Members.FavoriteSkillLimit} favorite skill limitation. you can't add another favorite skill.you should uncheck a skill to be able to add another skill as your favorite!`,
  removeCareerHistory: "Remove career history",
  removeJobPreferences: "Remove Job Preference",
  addPeymentMethod: "Add Payment method",
  defaultPeymentMethod: "Set Default Payment Method",
  removeLanguage: "Remove language",
  removeEducation: "Remove education",
  removeCertificate: "Remove certificate",
  confirmation: "Are you sure?",
  succesfullyAddCertificate: "Certificate has been added successfully!",
  errorAddCertificate: "Couldn't add education!",
  succesfullyUpdateCertificate: "Certificate has been updated successfully!",
  succesfullyDeleteCertificate: "Certificate has been Deleted successfully!",
  errorDeleteCertificate: "Couldn't delete certificate!",
  succesfullyAddEducation: "Education has been added successfully!",
  succesfullyEditEducation: "Education has been updated successfully!",
  errorAddEducation: "Couldn't save education!",
  succesfullyUpdateEducation: "Education has been updated successfully!",
  succesfullyRemoveSkill: "The skill has been removed successfully!",
  errorRemoveSkill: "Couldn't delete skill!",
  succesfullyDeleteEducation: "Education has been Deleted successfully!",
  errorDeleteEducation: "Couldn't delete education!",
  succesfullyAddExperienceDetail: "Experience details have been saved successfully!",
  succesfullyAddExperienceJobPreferences: "Experience Job Preference details have been saved successfully!",
  succesfullyRemoveExperienceJobPreferences: "Experience Job Preference details have been removed successfully!",
  errorAddExperienceDetail: "Couldn't save experience details!",
  errorAddExperienceJobPreferences: "Couldn't save experience Job Preference details!",
  ErrorDuplicateJobPreferences: "You already have this working position in the list. You can't add an item with duplicate working position!",
  errorRemoveExperienceJobPreferences: "Couldn't remove experience Job Preference details!",
  succesfullyAddPersonalDetails: "Personal details have been saved successfully!",
  succesfullyAddProfileDetails: "Profile details have been saved successfully!",
  succesfullyAddSkillDetails: "Skill details have been saved successfully!",
  vmNotificationSuccessfully: "Notification has been sent successfylly",
  vmNotificationError: "Ooops! something is wrong! coundln't send notification to selected teammembers!",
  errorAddPersonalDetails: "Couldn't save personal details!",
  succesfullyAddLanguageSkill: "Language has been added successfully!",
  succesfullyAddSkill: "Skill has been added successfully!",
  succesfullyUpdatedSkill: "Skill has been updated successfully!",
  errorAddSkill: "Couldn't save skill!",
  succesfullyUpdateLanguageSkill: "Language has been updated successfully!",
  succesfullyDeleteLanguageSkill: "Language has been Deleted successfully!",
  wiseAddMessage: "Are you sure you want to add this as your wise account?",
  bankAddMessage: "Are you sure you want to add this as your bank account?",
  paypalAddMessage: "Are you sure you want to add this as your paypal account?",
  paymentMethodMessage: "You are changing your payment method. After saving it you won't be able to change your payment method again for 6 month!",
  cryptoChangeDefaultMessage:
    "You are currently changing your wallet as your default wallet address. your deposits will be deposited into this wallet address after changing it to default mode. Are you sure you want to make this wallet address as your default?",
  bankChangeDefaultMessage:
    "You are currently changing your bank account as your default account. your deposits will be deposited into this account after changing it to default mode. Are you sure you want to make this bank account as your default?",
  wiseChangeDefaultMessage:
    "You are currently changing your wise account as your default account. your deposits will be deposited into this account after changing it to default mode. Are you sure you want to make this wise account as your default?",
  paypalChangeDefaultMessage:
    "You are currently changing your paypal account as your default account. your deposits will be deposited into this account after changing it to default mode. Are you sure you want to make this paypal account as your default?",
};
export const AlertMessages = {
  SuccessProfileUpdate: "Your profile updated successfully",
  ValidationErrorProfileUpdate: "Something went wrong, check validation errors and try again",
};
export const DarkThemeColors = {
  Primary: "#fff",
  Secondary: "#302c2b",
  Accent: "#dc1e28",
  Error: "#ff0000",
  Info: "#2196f3",
  Success: "#4caf50",
  Warning: "#ffc107",
  LightPink: "#FFDBDB",
  Pink: "#FFCCCC",
  Gray: "#c2c2c2",
};
export const StudyFields = [
  "Computer Science",
  "Business/Commerce, General",
  "Computer and Information Sciences and Support Services",
  "Communication and Media Studies",
  "Chemistry",
  "Computer Engineering",
  "Civil Engineering",
  "Chemical Engineering",
  "Electrical, Electronics and Communications Engineering",
  "Computer Systems Networking and Telecommunications",
  "Criminal Justice and Corrections",
  "Mass Communication/Media Studies",
  "Computer Software Engineering",
  "English Literature (British and Commonwealth)",
  "Computer Programming, Specific Applications",
  "Mathematics and Computer Science",
  "International Business/Trade/Commerce",
  "Counseling Psychology",
  "Logistics, Materials, and Supply Chain Management",
  "Health/Health Care Administration/Management",
  "Business Administration and Management, General",
  "Accounting",
  "English Language and Literature/Letters",
  "Political Science and Government",
  "Human Resources Management/Personnel Administration, General",
  "Architecture",
  "Accounting and Finance",
  "Liberal Arts and Sciences/Liberal Studies",
  "International Relations and Affairs",
  "Business, Management, Marketing, and Related Support Services",
  "Art/Art Studies, General",
  "Advertising",
  "Fine/Studio Arts, General",
  "Public Administration",
  "Business/Commerce, General",
  "Biology, General",
  "International Business",
  "Accounting and Business/Management",
  "Biotechnology",
  "Biomedical/Medical Engineering",
  "Business/Corporate Communications",
  "Banking and Financial Support Services",
  "Biology/Biological Sciences, General",
  "Banking, Corporate, Finance, and Securities Law",
  "Zoology/Animal Biology",
  "Molecular Biology",
  "Business Administration, Management and Operations",
  "Broadcast Journalism",
  "Chemistry",
  "Design and Visual Communications, General",
  "Film/Cinema/Video Studies",
  "Cinematography and Film/Video Production",
  "Veterinary Medicine",
  "Animation, Interactive Technology, Video Graphics and Special Effects",
  "Visual and Performing Arts",
  "Vocational Rehabilitation Counseling/Counselor",
  "Veterinary/Animal Health Technology/Technician and Veterinary Assistant",
  "Voice and Opera",
  "Virology",
  "Viticulture and Enology",
  "Photographic and Film/Video Technology/Technician and Assistant",
  "Veterinary Pathology and Pathobiology",
  "Film/Video and Photographic Arts",
  "Vision Science/Physiological Optics",
  "Practical Nursing, Vocational Nursing and Nursing Assistants",
  "Modeling, Virtual Environments and Simulation",
  "Veterinary Preventive Medicine, Epidemiology, and Public Health",
  "Veterinary Microbiology and Immunobiology",
  "Graphic Design",
  "Interior Design",
  "Industrial and Product Design",
  "Design and Applied Arts",
  "Fashion/Apparel Design",
  "Design and Visual Communications, General",
  "Dentistry",
  "Communication Sciences and Disorders, General",
  "Drama and Dramatics/Theatre Arts, General",
  "Development Economics and International Development",
  "Human Development and Family Studies, General",
  "Human Resources Development",
  "Pharmaceutics and Drug Design",
  "Data Processing",
  "Digital Communication and Media/Multimedia",
  "Dance",
  "Dietetics/Dietitian",
  "Business/Office Automation/Technology/Data Entry",
  "Dental Hygiene/Hygienist",
  "Divinity/Ministry",
  "Economics",
  "Mechanical Engineering",
  "Industrial Engineering",
  "Business/Managerial Economics",
  "Geology/Earth Science, General",
  "Elementary Education and Teaching",
  "Aerospace, Aeronautical and Astronautical Engineering",
  "Real Estate",
  "French Studies",
  "Sport and Fitness Administration/Management",
  "Foods, Nutrition, and Wellness Studies, General",
  "Fashion Merchandising",
  "Food Science",
  "International Finance",
  "French Language and Literature",
  "Marketing/Marketing Management, General",
  "Geography",
  "Microbiology, General",
  "Educational Leadership and Administration, General",
  "History",
  "Human Resources Management and Services",
  "Hospitality Administration/Management",
  "Art History, Criticism and Conservation",
  "Hotel/Motel Administration/Management",
  "Environmental/Environmental Health Engineering",
  "Humanities/Humanistic Studies",
  "Public Health",
  "Health and Physical Education/Fitness",
  "Health and Wellness, General",
  "Homeland Security, Law Enforcement, Firefighting and Related Protective Services",
  "Information Technology",
  "Public Relations/Image Management",
  "Spanish and Iberian Studies",
  "Library and Information Science",
  "Informatics",
  "International/Global Studies",
  "International Marketing",
  "Information Resources Management",
  "Journalism",
  "Japanese Studies",
  "Japanese Language and Literature",
  "Canadian Law/Legal Studies/Jurisprudence",
  "Criminal Justice/Safety Studies",
  "Jewish/Judaic Studies",
  "Jazz/Jazz Studies",
  "Agricultural Communication/Journalism",
  "American/U.S. Law/Legal Studies/Jurisprudence",
  "Junior High/Intermediate/Middle School Education and Teaching",
  "Watchmaking and Jewelrymaking",
  "Metal and Jewelry Arts",
  "Army JROTC/ROTC",
  "Air Force JROTC/ROTC",
  "Juvenile Corrections",
  "Navy/Marine Corps JROTC/ROTC",
  "Network",
  "Software engineering",
  "Hardware engineering",
  "Artificial Intelligence",
  "Data Structures and Algorithms",
  "Computer Architecture",
  "Game Design",
  "Robotics",
  "Security",
  "Computational Theory ",
  "Computer programming",
  "Distributed computing",
  "Computer graphics",
  "Image processing",
  "Human–computer interaction",
  "Data management",
  "Data mining",
  "Database ",
  "Information retrieval",
  "Information management",
  "Information system",
  "Information technology",
  "Knowledge management",
  "Multimedia, hypermedia",
  "Aerospace engineering",
  "Physics",
  "Earth sciences",
  "Sociology",
  "Literature",
  "Religion",
  "Philosophy",
  "Linguistics and languages",
  "History",
  "Archaeology",
  "Business",
  "Divinity",
];
export const EducationStatuses = ["Doctoral", "Master", "Bachelor", "Associate", "Highschool"];
//   export const EducationStatuses = [
//   "Bachelor's degree",
//   "Bachelor of Applied Science - BASc",
//   "Bachelor of Architecture - BArch",
//   "Bachelor of Arts - BA",
//   "Bachelor of Business Administration - BBA",
//   "Bachelor of Commerce - BCom",
//   "Bachelor of Education - BEd",
//   "Bachelor of Engineering - BE",
//   "Bachelor of Fine Arts - BFA",
//   "Bachelor of Laws - LLB",
//   "Bachelor of Medicine, Bachelor of Surgery - MBBS",
//   "Bachelor of Pharmacy - BPharm",
//   "Bachelor of Science - BS",
//   "Bachelor of Technology - BTech",
//   "Master's degree",
//   "Master of Architecture - MArch",
//   "Master of Arts - MA",
//   "Master of Business Administration - MBA",
//   "Master of Computer Applications - MCA",
//   "Master of Divinity - MDiv",
//   "Master of Education - MEd",
//   "Master of Engineering - ME",
//   "Master of Fine Arts - MFA",
//   "Master of Laws - LLB",
//   "Master of Library & Information Science - MLIS",
//   "Master of Philosophy - MPhil",
//   "Master of Public Administration - MPA",
//   "Master of Public Health - MPH",
//   "Master of Science - MS",
//   "Master of Social Work - MSW",
//   "Master of Technology - MTech",
//   "High School Diploma",
//   "Higher National Diploma",
//   "Middle School Diploma",
//   "Diploma of Education",
//   "Associate's degree",
//   "Associate of Arts - AA",
//   "Associate of Arts and Sciences - AAS",
//   "Associate of Science - AS",
//   "Doctor's Degree",
//   "Doctor of Philosophy - PhD",
//   "Doctor of Arts - DA",
//   "Doctor of Medicine - MD",
//   "Doctor of Education - EDD",
//   "Doctor of Laws",
//   "Doctor of Pharmacy - PharmD",
//   "Doctor of Science",
//   "",
//   "",
// ];
export const MilitaryServiceSituations = ["N/A", "Finished", "Serving", "Exemption", "Not Applicable", "Prefer not to disclose ", "Other"];
export const MaritalStatus = ["N/A", "Single", "Married", "Divorced", "Not Applicable", "Prefer not to disclose ", "Other"];
export const Nationalities = [
  "Afghan",
  "Albanian",
  "Algerian",
  "American",
  "Andorran",
  "Angolan",
  "Antiguans",
  "Argentinean",
  "Armenian",
  "Australian",
  "Austrian",
  "Azerbaijani",
  "Bahamian",
  "Bahraini",
  "Bangladeshi",
  "Barbadian",
  "Barbudans",
  "Batswana",
  "Belarusian",
  "Belgian",
  "Belizean",
  "Beninese",
  "Bhutanese",
  "Bolivian",
  "Bosnian",
  "Brazilian",
  "British",
  "Bruneian",
  "Bulgarian",
  "Burkinabe",
  "Burmese",
  "Burundian",
  "Cambodian",
  "Cameroonian",
  "Canadian",
  "Cape Verdean",
  "Central African",
  "Chadian",
  "Chilean",
  "Chinese",
  "Colombian",
  "Comoran",
  "Congolese",
  "Costa Rican",
  "Croatian",
  "Cuban",
  "Cypriot",
  "Czech",
  "Danish",
  "Djibouti",
  "Dominican",
  "Dutch",
  "East Timorese",
  "Ecuadorean",
  "Egyptian",
  "Emirian",
  "Equatorial Guinean",
  "Eritrean",
  "Estonian",
  "Ethiopian",
  "Fijian",
  "Filipino",
  "Finnish",
  "French",
  "Gabonese",
  "Gambian",
  "Georgian",
  "German",
  "Ghanaian",
  "Greek",
  "Grenadian",
  "Guatemalan",
  "Guinea-Bissauan",
  "Guinean",
  "Guyanese",
  "Haitian",
  "Herzegovinian",
  "Honduran",
  "Hungarian",
  "I-Kiribati",
  "Icelander",
  "Indian",
  "Indonesian",
  "Iranian",
  "Iraqi",
  "Irish",
  "Israeli",
  "Italian",
  "Ivorian",
  "Jamaican",
  "Japanese",
  "Jordanian",
  "Kazakhstani",
  "Kenyan",
  "Kittian and Nevisian",
  "Kuwaiti",
  "Kyrgyz",
  "Laotian",
  "Latvian",
  "Lebanese",
  "Liberian",
  "Libyan",
  "Liechtensteiner",
  "Lithuanian",
  "Luxembourger",
  "Macedonian",
  "Malagasy",
  "Malawian",
  "Malaysian",
  "Maldivan",
  "Malian",
  "Maltese",
  "Marshallese",
  "Mauritanian",
  "Mauritian",
  "Mexican",
  "Micronesian",
  "Moldovan",
  "Monacan",
  "Mongolian",
  "Moroccan",
  "Mosotho",
  "Motswana",
  "Mozambican",
  "Namibian",
  "Nauruan",
  "Nepalese",
  "New Zealander",
  "Nicaraguan",
  "Nigerian",
  "Nigerien",
  "North Korean",
  "Northern Irish",
  "Norwegian",
  "Omani",
  "Pakistani",
  "Palauan",
  "Panamanian",
  "Papua New Guinean",
  "Paraguayan",
  "Peruvian",
  "Polish",
  "Portuguese",
  "Qatari",
  "Romanian",
  "Russian",
  "Rwandan",
  "Saint Lucian",
  "Salvadoran",
  "Samoan",
  "San Marinese",
  "Sao Tomean",
  "Saudi",
  "Scottish",
  "Senegalese",
  "Serbian",
  "Seychellois",
  "Sierra Leonean",
  "Singaporean",
  "Slovakian",
  "Slovenian",
  "Solomon Islander",
  "Somali",
  "South African",
  "South Korean",
  "Spanish",
  "Sri Lankan",
  "Sudanese",
  "Surinamer",
  "Swazi",
  "Swedish",
  "Swiss",
  "Syrian",
  "Taiwanese",
  "Tajik",
  "Tanzanian",
  "Thai",
  "Togolese",
  "Tongan",
  "Trinidadian or Tobagonian",
  "Tunisian",
  "Turkish",
  "Tuvaluan",
  "Ugandan",
  "Ukrainian",
  "Uruguayan",
  "Uzbekistani",
  "Venezuelan",
  "Vietnamese",
  "Welsh",
  "Yemenite",
  "Zambian",
  "Zimbabwean",
];

export const ProfileFields = {
  Timezones: [
    "(UTC+10:00) Australian Eastern Standard Time (AEST)",
    "(UTC-12:00) International Date Line West",
    "(UTC-11:00) Coordinated Universal Time-11",
    "(UTC-10:00) Aleutian Islands",
    "(UTC-10:00) Hawaii",
    "(UTC-09:30) Marquesas Islands",
    "(UTC-09:00) Alaska",
    "(UTC-09:00) Coordinated Universal Time-09",
    "(UTC-08:00) Baja California",
    "(UTC-08:00) Coordinated Universal Time-08",
    "(UTC-08:00) Pacific Time (US & Canada)",
    "(UTC-07:00) Arizona",
    "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
    "(UTC-07:00) Mountain Time (US & Canada)",
    "(UTC-07:00) Yukon",
    "(UTC-06:00) Central America",
    "(UTC-06:00) Central Time (US & Canada)",
    "(UTC-06:00) Easter Island",
    "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
    "(UTC-06:00) Saskatchewan",
    "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
    "(UTC-05:00) Chetumal",
    "(UTC-05:00) Eastern Time (US & Canada)",
    "(UTC-05:00) Haiti",
    "(UTC-05:00) Havana",
    "(UTC-05:00) Indiana (East)",
    "(UTC-05:00) Turks and Caicos",
    "(UTC-04:00) Asuncion",
    "(UTC-04:00) Atlantic Time (Canada)",
    "(UTC-04:00) Caracas",
    "(UTC-04:00) Cuiaba",
    "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
    "(UTC-04:00) Santiago",
    "(UTC-03:30) Newfoundland",
    "(UTC-03:00) Araguaina",
    "(UTC-03:00) Brasilia",
    "(UTC-03:00) Cayenne, Fortaleza",
    "(UTC-03:00) City of Buenos Aires",
    "(UTC-03:00) Greenland",
    "(UTC-03:00) Montevideo",
    "(UTC-03:00) Punta Arenas",
    "(UTC-03:00) Saint Pierre and Miquelon",
    "(UTC-03:00) Salvador",
    "(UTC-02:00) Coordinated Universal Time-02",
    "(UTC-02:00) Mid-Atlantic - Old",
    "(UTC-01:00) Azores",
    "(UTC-01:00) Cabo Verde Is.",
    "(UTC) Coordinated Universal Time",
    "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
    "(UTC+00:00) Monrovia, Reykjavik",
    "(UTC+00:00) Sao Tome",
    "(UTC+01:00) Casablanca",
    "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
    "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    "(UTC+01:00) West Central Africa",
    "(UTC+02:00) Amman",
    "(UTC+02:00) Athens, Bucharest",
    "(UTC+02:00) Beirut",
    "(UTC+02:00) Cairo",
    "(UTC+02:00) Chisinau",
    "(UTC+02:00) Damascus",
    "(UTC+02:00) Gaza, Hebron",
    "(UTC+02:00) Harare, Pretoria",
    "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    "(UTC+02:00) Jerusalem",
    "(UTC+02:00) Kaliningrad",
    "(UTC+02:00) Khartoum",
    "(UTC+02:00) Tripoli",
    "(UTC+02:00) Windhoek",
    "(UTC+03:00) Baghdad",
    "(UTC+03:00) Istanbul",
    "(UTC+03:00) Kuwait, Riyadh",
    "(UTC+03:00) Minsk",
    "(UTC+03:00) Moscow, St. Petersburg",
    "(UTC+03:00) Nairobi",
    "(UTC+03:30) Tehran",
    "(UTC+04:00) Abu Dhabi, Muscat",
    "(UTC+04:00) Astrakhan, Ulyanovsk",
    "(UTC+04:00) Baku",
    "(UTC+04:00) Izhevsk, Samara",
    "(UTC+04:00) Port Louis",
    "(UTC+04:00) Saratov",
    "(UTC+04:00) Tbilisi",
    "(UTC+04:00) Volgograd",
    "(UTC+04:00) Yerevan",
    "(UTC+04:30) Kabul",
    "(UTC+05:00) Ashgabat, Tashkent",
    "(UTC+05:00) Ekaterinburg",
    "(UTC+05:00) Islamabad, Karachi",
    "(UTC+05:00) Qyzylorda",
    "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    "(UTC+05:30) Sri Jayawardenepura",
    "(UTC+05:45) Kathmandu",
    "(UTC+06:00) Astana",
    "(UTC+06:00) Dhaka",
    "(UTC+06:00) Omsk",
    "(UTC+06:30) Yangon (Rangoon)",
    "(UTC+07:00) Bangkok, Hanoi, Jakarta",
    "(UTC+07:00) Barnaul, Gorno-Altaysk",
    "(UTC+07:00) Hovd",
    "(UTC+07:00) Krasnoyarsk",
    "(UTC+07:00) Novosibirsk",
    "(UTC+07:00) Tomsk",
    "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    "(UTC+08:00) Irkutsk",
    "(UTC+08:00) Kuala Lumpur, Singapore",
    "(UTC+08:00) Perth",
    "(UTC+08:00) Taipei",
    "(UTC+08:00) Ulaanbaatar",
    "(UTC+08:45) Eucla",
    "(UTC+09:00) Chita",
    "(UTC+09:00) Osaka, Sapporo, Tokyo",
    "(UTC+09:00) Pyongyang",
    "(UTC+09:00) Seoul",
    "(UTC+09:00) Yakutsk",
    "(UTC+09:30) Adelaide",
    "(UTC+09:30) Darwin",
    "(UTC+10:00) Brisbane",
    "(UTC+10:00) Canberra, Melbourne, Sydney",
    "(UTC+10:00) Guam, Port Moresby",
    "(UTC+10:00) Hobart",
    "(UTC+10:00) Vladivostok",
    "(UTC+10:30) Lord Howe Island",
    "(UTC+11:00) Bougainville Island",
    "(UTC+11:00) Chokurdakh",
    "(UTC+11:00) Magadan",
    "(UTC+11:00) Norfolk Island",
    "(UTC+11:00) Sakhalin",
    "(UTC+11:00) Solomon Is., New Caledonia",
    "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
    "(UTC+12:00) Auckland, Wellington",
    "(UTC+12:00) Coordinated Universal Time+12",
    "(UTC+12:00) Fiji",
    "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
    "(UTC+12:45) Chatham Islands",
    "(UTC+13:00) Coordinated Universal Time+13",
    "(UTC+13:00) Nuku'alofa",
    "(UTC+13:00) Samoa",
    "(UTC+14:00) Kiritimati Island",
  ],
};
export const AuditTrailRecordTypes = {
  Timesheet: "Timesheet",
  Payrun: "Payrun",
};
export const AuditTrailEvents = {
  Create: "Create",
  Update: "Update",
  Delete: "Delete",
  AdminApprove: "Admin Approve",
  TMApprove: "TM Approve",
  PaymentRefAdd: "Payment Ref added",
};

export const Currencies = [
  { id: "TMN", name: "Toman", isDefault: true, isMain: false },
  { id: "USDT", name: "USD Tether", isDefault: false, isMain: false },
  { id: "MYR", name: "Malaysian Ringgits", isDefault: false, isMain: false },
  { id: "PHP", name: "Philippine Pesos", isDefault: false, isMain: false },
  { id: "AUD", name: "Australian Dollar", isDefault: false, isMain: true },
];

export const BiographyQuestions = [
  {
    title: "Please choose one statement that best describes you, and one that least describes you.",
    selected: "",
    choices: [
      "I like to analyze and evaluate information.",
      "I am an effective negotiator.",
      "I strive to be in a position of power.",
      "I always plan my expenses in advance.",
    ],
  },
  {
    title: "Please choose one statement that best describes you, and one that least describes you.",
    selected: "",
    choices: [
      "I tend to analyze people.",
      "I pick my words very carefully.",
      "I make a grocery list before going to the store.",
      "Selling comes easily to me.",
    ],
  },
  {
    title: "Please choose one statement that best describes you, and one that least describes you.",
    selected: "",
    choices: [
      "Most people show that they are happy to see me.",
      "I often find ways to break down difficult problems into manageable components.",
      "When I imagine how things will truly feel, I can almost get the actual sensation.",
      "I keep others in line.",
    ],
  },
];
